// extracted by mini-css-extract-plugin
module.exports = {"destinationsSwiper":"SignatureDestinations_destinationsSwiper__B7Wft","signatureDestinationsDesktopCarousel":"SignatureDestinations_signatureDestinationsDesktopCarousel__XLbft"};